import { authenticatedFetch } from '../../api/request';

export const FEATURES = {
    MARKETPLACE_COACH_PURCHASE_FLOW_V1: 'marketplace_coach_purchase_flow_v1',
    TEST_FEATURE: 'test_feature',
    WEB_TEAM_SUBSCRIPTION_MANAGEMENT_V1: 'web_team_subscription_management_v1'
};

export default function getFeaturesForUserId(userId: number) {
    return authenticatedFetch(`/v5/users/${userId}/features`);
}
